// ./src/components/generic/StatusBadge/StatusBadge.tsx
import React from "react";
import { Badge } from "@mantine/core";

export interface StatusBadgeProps {
  status?: number | undefined | null;
}

const statuses: any = {
  "-1": { label: "Unknown", color: "gray" },
  0: { label: "Disabled", color: "red" },
  100: { label: "Active", color: "green" },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const badgeInfo = statuses[status != null ? status : "-1"];

  return (
    <Badge color={badgeInfo.color} variant="light" size="sm">
      {badgeInfo.label}
    </Badge>
  );
};
